/**
 * 留言加精/取消加精
 * @author Kody
 * @see http://api.umucdn.cn/project/232/interface/api/4319
 */

import Api from '../../path';
import { fetchData } from '@umu/umu-fetch';

interface IInput {
    message_id: string;
    is_elite: string; // 0 | 1
}

export const postMessageElite = (param: IInput): Promise<IStatusResponse> => {
    return fetchData(Api.PROFILE_MESSAGE_ELITE, param);
};
